import * as React from "react";
// 浏览器消息模型
import BrowserNoticeModel from "./browserNoticeModel";

// 浏览器消息
class BrowserNotice extends React.Component<any, any> {
  state = {
    permission: "default" as NotificationPermission
  };
  constructor(props: any) {
    super(props);
    const permission: NotificationPermission = Notification.permission;
    // 先检查浏览器是否支持
    if (!("Notification" in window)) {
      alert("This browser does not support desktop notification");
    }

    // 检查用户是否同意接受通知
    else if (permission == ("granted" as NotificationPermission)) {
      // If it's okay let's create a notification
      //new Notification("Hi there!");
      this.state = {
        permission: "granted"
      };
    }

    // 否则我们需要向用户获取权限
    else if (permission !== "denied") {
      Notification.requestPermission(permission => {
        this.state = {
          permission: permission
        };
      });
    }
  }

  componentWillMount() {
    const bnm = new BrowserNoticeModel();
    bnm.title = "8月1日 17:20";
    bnm.body = "12321321321321312";
    bnm.icon = require("styles/img/notice.png");
    bnm.tag = "1";
    bnm.handle = () => {
      alert("haha");
    };
    //this.showMsg(bnm);
  }

  showMsg = (data: BrowserNoticeModel) => {
    if (this.state.permission == "granted") {
      const notification = new Notification(data.title, {
        body: data.body,
        icon: data.icon
      });

      notification.onclick = data.handle || (() => {});
    }
  };

  render() {
    return <React.Fragment />;
  }
}

export default BrowserNotice;
